import type { ElementRef } from '@angular/core';
import { ChangeDetectorRef, Component, output } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { TranslatePipe } from '@recruitee/i18n';
import { SymbolPickerService } from '@recruitee/symbol';
import { RtTooltip, IconButtonComponent } from '@recruitee/user-interface';

@Component({
  selector: 'rt-add-reaction-button',
  template: `
    <rt-icon-button
      #buttonComponent
      [rtTooltip]="'app.reactions.tooltip_add_reaction' | translate"
      variant="plain"
      (click)="openEmojiPicker(buttonComponent.elRef)"
      iconName="add-reaction"
      shape="square"
      size="small"
    >
    </rt-icon-button>
  `,
  providers: [SymbolPickerService],
  imports: [IconButtonComponent, RtTooltip, TranslatePipe],
})
export class AddReactionButtonComponent {
  public select = output<string>();

  private ngOnDestroy$ = new Subject<void>();
  constructor(
    private symbolPickerService: SymbolPickerService,
    private cdRef: ChangeDetectorRef,
  ) {}

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }

  public openEmojiPicker(elRef: ElementRef<HTMLElement>) {
    const rect = elRef.nativeElement.getBoundingClientRect();

    this.symbolPickerService
      .open(rect, { withSearchInput: true, dataSources: ['emojis'] })
      .select$.pipe(takeUntil(this.ngOnDestroy$.asObservable()))
      .subscribe(selection => {
        this.select.emit(selection.value.symbol);
        this.symbolPickerService.close();
        this.cdRef.detectChanges();
      });
  }
}
